import { createSlice } from "@reduxjs/toolkit";

const trainingSlice = createSlice({
  name: "training",
  initialState: {
    loading: false,
    training: null,
    trainingData: [],
    trainingActivity: [],
    total: 0,
    error: null,
  },

  reducers: {
    saveTrainingRequest: (state) => {
      state.loading = true;
    },

    saveTrainingSuccess: (state, action) => {
      state.loading = false;
      state.training = action.payload;
    },

    saveTrainingFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },

    getTrainingsRequest: (state) => {
      state.loading = true;
    },

    getTrainingsSuccess: (state, action) => {
      state.loading = false;
      state.trainingData = action?.payload?.data?.data || [];
      state.total = action?.payload?.data?.total || 0;
    },

    getTrainingsFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
    updateTrainingStatusRequest: (state) => {
      state.loading = true;
    },

    updateTrainingStatusSuccess: (state, action) => {
      state.loading = false;

      const updated = action.payload;

      state.trainingData = state.trainingData.map((item) =>
        item._id === updated._id ? updated : item,
      );
    },

    updateTrainingStatusFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
    getTrainingActivityRequest: (state) => {
      state.loading = true;
    },

    getTrainingActivitySuccess: (state, action) => {
      state.loading = false;
      state.trainingActivity = action.payload?.data || [];
    },

    getTrainingActivityFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
  },
});

export const {
  saveTrainingRequest,
  saveTrainingSuccess,
  saveTrainingFailure,
  getTrainingsRequest,
  getTrainingsSuccess,
  getTrainingsFailure,
  updateTrainingStatusRequest,
  updateTrainingStatusSuccess,
  updateTrainingStatusFailure,
  getTrainingActivityRequest,
  getTrainingActivitySuccess,
  getTrainingActivityFailure,
} = trainingSlice.actions;

export default trainingSlice.reducer;
